export class ChannelTicketTypeRequestQueryModel {
    
    companyId!: number;
    salesChannelId!: number;
    eventId!: number;
    ticketName?: string;
}
